import { useContext, useEffect, useState } from "react";
import useOffer from "../../api/hooks/useOffers";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import { Offer } from "../../interfaces";
import {
  getOffersByClient,
  getOffersByStatus,
  getSuccessRate,
} from "../../utils/getMethods";

const ClientProposal = (props: any) => {
  const { isMobile } = useIsMobile();

  const { client } = props;

  const { token, refresh } = useContext(MainContext);
  const { RESPONSES, RESULTS, CTAs } = useOffer();
  const [offersFetched, setOffersFetched] = useState<Offer[]>([]);
  const [stats, setStats] = useState({
    successRate: 0,
    approvedTimes: 0,
    proposedTimes: 0,
  });

  useEffect(() => {
    CTAs.getOffersListAll();
  }, [refresh]);

  useEffect(() => {
    /* console.log(
      RESPONSES.getOffersListAllResponse,
      RESULTS.getOffersListAllResult
    ); */
    if (RESPONSES.getOffersListAllResponse?.ok) {
      setOffersFetched(RESULTS.getOffersListAllResult.offerts);
    }
  }, [RESPONSES.getOffersListAllResponse]);

  useEffect(() => {
    if (offersFetched) { 
      setStats({
        successRate: clientProposalStats().successRate,
        approvedTimes: clientProposalStats().approvedTimes,
        proposedTimes: clientProposalStats().proposedTimes,
      });
    }
  }, [offersFetched]);

  const clientProposalStats = () => {
    let offers: Offer[] = [];
    offers = getOffersByClient(offersFetched, client.name);
    offers = getOffersByStatus(offers, "closed");
    let totalProposedTimes = 0;
    let totalApprovedTimes = 0;
    offers.forEach((offer) => { 
      totalProposedTimes =
        totalProposedTimes + offer.models_proposed_list!.length;
      totalApprovedTimes =
        totalApprovedTimes + offer.models_accepted_list!.length;
    });
    let successRate = getSuccessRate(totalProposedTimes, totalApprovedTimes);
    return {
      proposedTimes: totalProposedTimes,
      approvedTimes: totalApprovedTimes,
      successRate: successRate,
    };
  };

  const firstPair = stats.successRate.toString().substring(0, 2);
  const secondPair = stats.successRate.toString().substring(3, 5);

  return (
    <div
      className="proposal"
      style={{
        flexDirection: isMobile ? "column" : "row",
        width: isMobile ? "calc(345px - 80px)" : "calc(1054px - 80px)",
        height: isMobile ? "fit-content" : "",
        margin: isMobile ? "18px auto" : "",
        justifyContent: "center",
        gap: isMobile ? "56px" : "200px",
      }}
    >
      <div className="client-propsal-prop-box">
        <p className="rate-field" style={{ margin: "0", width: "fit-content" }}>
          Amount Spent
        </p>
        <div className="rate-value-box" style={{ marginTop: "13px" }}>
          <span className="rate-value">
            <p
              className="rate-value-primary"
              style={{ margin: "0", width: "fit-content" }}
            >
              € {props.client?.amount_spent}
            </p>
          </span>
        </div>
      </div>
      <div className="client-propsal-prop-box">
        <p className="rate-field" style={{ margin: "0" }}>
          Proposal
        </p>
        <div className="rate-value-box" style={{ marginTop: "13px" }}>
          <span className="rate-value">
            <p className="rate-value-primary" style={{ margin: "0" }}>
              {clientProposalStats().approvedTimes}
            </p>
            <p className="rate-value-secondary" style={{ margin: "0" }}>
              /{clientProposalStats().proposedTimes}
            </p>
          </span>
          <span className="rate-trend-box">
            <div className="rate-trend-iconBG">
              <img
                className="rate-trend-icon white"
                src={`${toIcons}/small-up.svg`}
              />
            </div>
            <p className="rate-trend-percentage">{/* SUCCESS RATE ???*/}%</p>
          </span>
        </div>
      </div>
      <div className="client-propsal-prop-box">
        <p className="rate-field" style={{ margin: "0" }}>
          Success Rate
        </p>
        <div className="rate-value-box" style={{ marginTop: "13px" }}>
          <span className="rate-value">
            <p className="rate-value-primary" style={{ margin: "0" }}>
              {firstPair}
            </p>
            <p className="rate-value-secondary" style={{ margin: "0" }}>
              ,
              {stats.successRate === 0 || secondPair === "" ? "00" : secondPair}
              %
            </p>
          </span>
          <span className="rate-trend-box">
            <div className="rate-trend-iconBG">
              <img
                className="rate-trend-icon white"
                src={`${toIcons}/small-up.svg`}
              />
            </div>
            <p className="rate-trend-percentage">{/* SUCCESS RATE ???*/}%</p>
          </span>
        </div>
      </div>
    </div>
  );
};
export default ClientProposal;
